/* import __COLOCATED_TEMPLATE__ from './page.hbs'; */
var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'transform-class-properties is enabled and runs after the decorators transform.'); }
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { CardStatus } from '@square/dashboard-protos/models/squareup/bbdebit/cardmanagement';
import { getBusinessName, getCardholder, getCvc, getExpirationDateString, getFullPan } from '@banking/ui/utils/card/card';
import { inject as service } from '@ember/service';
import { getImageUriFromCardCustomization } from '@banking/ui/utils/card/image-bytes-utils';
const getCardPreviewFromCard = (card, cardCustomization) => {
  return {
    businessName: getBusinessName(card),
    cardholder: getCardholder(card),
    customizationImageDataURL: getImageUriFromCardCustomization(cardCustomization),
    cvc: getCvc(card),
    expirationDate: getExpirationDateString(card),
    fullPan: getFullPan(card)
  };
};
const EMPTY_CARD = {
  businessName: '',
  cardholder: '',
  customizationImageDataURL: '',
  cvc: '',
  expirationDate: '',
  fullPan: ''
};
let Index = (_class = class Index extends Component {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "intl", _descriptor, this);
    _defineProperty(this, "CardStatus", CardStatus);
    // TODO(cvu): support different card brands once it's available in Card model
    _initializerDefineProperty(this, "cardIdentifierText", _descriptor2, this);
  }
  get cardPreview() {
    if (this.args.card && this.args.cardCustomization) {
      return {
        ...getCardPreviewFromCard(this.args.card, this.args.cardCustomization),
        showCardDetails: this.args.showCardDetails
      };
    }
    return EMPTY_CARD;
  }
  get title() {
    const cardholder = getCardholder(this.args.card);
    return cardholder.length > 0 ? this.intl.t('banking.checking.cardSettings.page.title', {
      cardholder: getCardholder(this.args.card)
    }) : '';
  }

  // TODO(cvu): support owner card copy when we start supporting owner card
  get shippingText() {
    const cardholder = getCardholder(this.args.card);
    return cardholder.length > 0 ? this.intl.t('banking.checking.cardSettings.page.status.shipping.text.authorizedUser', {
      cardholder: getCardholder(this.args.card)
    }) : '';
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "intl", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "cardIdentifierText", [tracked], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: function () {
    return `Mastercard ${this.args.card.lastFour}`;
  }
})), _class);
export { Index as default };